import React from "react"
import clsx from "clsx"
import { Paper, Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      boxShadow: theme.cards.hoverCard.boxShadow
    },
    "&:focus": {
      boxShadow: theme.cards.hoverCard.boxShadow
    }
  },
  selected: {
    border: `2px solid ${theme.palette.grey[400]}`
  },
  completed: {
    backgroundColor: theme.palette.success.background,
    border: `2px solid ${theme.palette.success.main}`
  },
  overdue: {
    border: `2px solid ${theme.palette.error.main}`
  },
  warning: {
    border: `2px solid ${theme.palette.warning.main}`
  },
  skipped: {
    backgroundColor: theme.palette.grey[100],
    border: `2px solid ${theme.palette.grey[400]}`
  }
}))

const PaperBox = ({
  children,
  elevation = 0,
  fullWidth = false,
  fullHeight = false,
  selected,
  completed,
  skipped,
  warning,
  overdue,
  paperProps,
  boxProps,
  className = "",
  ...props
}) => {
  const classes = useStyles()

  const displayClasses = [className, classes.root]
  if (selected) displayClasses.push(classes.selected)
  if (completed) displayClasses.push(classes.completed)
  if (overdue) displayClasses.push(classes.overdue)
  if (skipped) displayClasses.push(classes.skipped)
  if (warning) displayClasses.push(classes.warning)

  return (
    <Paper
      elevation={elevation}
      style={{
        width: fullWidth ? "100%" : null,
        height: fullHeight ? "100%" : null
      }}
      className={clsx(displayClasses)}
      {...paperProps}
    >
      <Box {...props} {...boxProps}>
        {children}
      </Box>
    </Paper>
  )
}

export { PaperBox }
